import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function Item ( props ) {

    return <BasicCrudScreenType id="Item" table="Item" view="VwItem" />;

}

export default Item;
